// extracted by mini-css-extract-plugin
export default {"content":"CellContentOverflow_content__1Lc7g","placeHolderShimmer":"CellContentOverflow_placeHolderShimmer__LPq+A"};